module.exports = __webpack_public_path__ + "static/media/ic_annually_plan.3f923326.svg";